import "datatables.net";
import "../components/hs-datatables";
import "flatpickr";
import "../components/hs-range-datepicker";
import "../components/hs-selectpicker";
import "../components/hs-chart-pie";
import "../components/hs-progress-bar";

export default {
  init() {

  },
  finalize() {

    $( ".printbutton" ).on("click", function () {
      printDiv('printableArea');
    });

   function printDiv(divName) {   
      $("#planprintname").show(); 
      var printContents = document.getElementById(divName).innerHTML;
      var originalContents = document.body.innerHTML;
      document.body.innerHTML = printContents;
      window.print();
      document.body.innerHTML = originalContents;
      $("#planprintname").hide();
      window.location.reload(true);
    }


    $(".remove-listingfrom-plan-staff").on("click", function () {
      var lp_id = $(this).data("lp-id");
      var plan_id = $(this).data("plan-id");
      var action="removeplanlisting";
      var url = ajaxdta.ajaxurl + "?action=plan_listing_modifications";
      
      $.ajax({
        type: "POST",
        url: url,
        data: {
          lp_id: lp_id, action:action, plan_id:plan_id
        },
        dataType:"JSON",
        success: function (data) { 
          var mString = data.count;
          if(mString) {
            $("#staffplanlisting"+ lp_id).hide(); 
          }else{
            $("html, body").animate({scrollTop: 0}, 'slow');
              $(".errormessage").html("* Failed to remove the listing from the plan");
              $(".errormessage").fadeOut(10000);
          }
        },
      });
    });
   

    $(".download-plan-staff").on("click", function () {
        var id_list = $(this).data("id-list");
        var url = ajaxdta.ajaxurl + "?action=get_lp_search_results";
  
        $.ajax({
          type: "POST",
          url: url,
          data: {
            id_list: id_list,
          },
          success: function (res, status, xhr) {
            var csvData = new Blob([res], { type: "text/csv;charset=utf-8;" });
            var csvURL = window.URL.createObjectURL(csvData);
            var tempLink = document.createElement("a");
            tempLink.href = csvURL;
            tempLink.setAttribute(
              "download",
              `learning-pathways.csv`
            );
            tempLink.click();
          },
        });
      });

      $(".edit-plan-name").on("click", function () {
        $("#plan_name").show(); 
        $("#planname").hide(); 
        $(".pencilbutton").hide();
    });

    $("#plan_name").focusout(function(){

      var planname = $('#plan_name').val();
      var planid = $('#planid').val();
      var url = ajaxdta.ajaxurl + "?action=rename-plan";
      var action="renameplan";

      $.ajax({
        type: "POST",
        url: url,
        data: {
          planname: planname,planid:planid, action:action
        },
        dataType:"JSON",
        success: function (data) { 
          var mString = data.location;
          var success =  data.success;
          if(success){
            location.href = mString;
          }else{
              location.href = mString;
              $("html, body").animate({scrollTop: 0}, 'slow');
              $(".errormessage").html("* Error in Renaming -  Plan Name already exists for the user");
              $(".errormessage").fadeOut(10000); 
          }
        },
      });

  
    });

},
};


// WEBPACK FOOTER //
// ./scripts/routes/training-plan-builder-plan-listing.js